import { AppRouteProps } from "@bsm/component";
import { StudentDetailsParamsContainer } from "./container/StudentDetailsParamsContainer";

export const StudentDetailsParamsRoutes: Array<AppRouteProps> = [
    {
        path: "params",
        element: <StudentDetailsParamsContainer />,
    },
];